import React from 'react';
import {
  Paper,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { HotelInfo } from '@features/deals/types';

interface PropertyDetailsCardProps {
  hotelInfo: HotelInfo;
}

const PropertyDetailsCard: React.FC<PropertyDetailsCardProps> = ({ hotelInfo }) => {
  return (
    <Paper
      sx={{
        p: 3,
        height: '100%',
        borderRadius: 2,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: '#ffffff'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <BusinessIcon sx={{ mr: 1, color: '#1a237e' }} />
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a237e' }}>
          Property Details
        </Typography>
      </Box>
      <TableContainer>
        <Table size="small">
          <TableBody>
            {Object.entries(hotelInfo)
              .filter(([key]) => !['id', 'notes', 'description'].includes(key))
              .map(([key, value]) => {
                let displayValue = value;
                if (key === 'star_rating') {
                  displayValue = `${value} Stars`;
                } else if (key === 'num_rooms') {
                  displayValue = `${value} Rooms`;
                } else if (key === 'lot_size') {
                  displayValue = `${value} sq ft`;
                } else if (Array.isArray(value)) {
                  displayValue = value.join(', ');
                } else if (value === null || value === undefined) {
                  displayValue = '-';
                }

                return (
                  <TableRow
                    key={key}
                    sx={{
                      '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
                      '&:last-child td, &:last-child th': { border: 0 }
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        py: 1.5,
                        px: 2,
                        fontWeight: 500,
                        color: '#424242', // Dark gray for labels
                        width: '40%',
                        fontSize: '0.875rem'
                      }}
                    >
                      {key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                    </TableCell>
                    <TableCell
                      sx={{
                        py: 1.5,
                        px: 2,
                        color: '#000000', // Black for values
                        fontSize: '0.875rem',
                        fontWeight: 400
                      }}
                    >
                      {displayValue}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PropertyDetailsCard;